"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("./Button"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var Switch =
/** @class */
function (_super) {
  __extends(Switch, _super);
  /**
   * Initializes and returns a switch control instance with the specified configuration options.
   *
   * @param {*} [opts]
   * @memberof Switch
   */


  function Switch(opts) {
    var _this = this;

    opts = (0, _utils.extend)({
      loader: false
    }, opts, {
      className: opts.className ? "ui-switch " + opts.className : 'ui-switch'
    }); // normalize values array

    if (opts.values) {
      opts.values = opts.values.map(function (v) {
        if (!(0, _utils.isPlainObject)(v)) {
          return {
            label: v,
            value: v
          };
        }

        return v;
      });
    }

    _this = _super.call(this, opts) || this;
    return _this;
  }

  Object.defineProperty(Switch.prototype, "value", {
    /**
     * Current value based on the switch selected state.
     *
     * @readonly
     * @type {*}
     * @memberof Switch
     */
    get: function () {
      var _this = this;

      var value = this.opts.value;
      var values = this.opts.values;

      if (values) {
        values.forEach(function (v, index) {
          if (_this.selected && index === 1) {
            value = v.value || v;
          } else if (!_this.selected && index === 0) {
            value = v.value || v;
          }
        });
      }

      return value;
    },
    enumerable: false,
    configurable: true
  });

  Switch.prototype._render = function (data) {
    var _a = this.opts,
        label = _a.label,
        values = _a.values;
    var labels = {
      left: '',
      right: ''
    };

    if (values) {
      values.forEach(function (v, index) {
        var key = index === 0 ? 'left' : 'right';
        var content = '';

        if ((0, _utils.isPlainObject)(v)) {
          content = v.label;
        } else {
          content = v;
        }

        labels[key] = "<div class=\"awxjs__ui-switch-label awxjs__ui-switch-label-" + key + "\">" + content + "</div>";
      });
    }

    return "\n\t\t\t<div class=\"awxjs__ui-switch\">\n\t\t\t\t" + (label ? "<div class=\"awxjs__ui-switch-label\">" + label + "</div>" : '') + "\n\t\t\t\t" + labels.left + "\n\t\t\t\t<div class=\"awxjs__ui-switch__control\">\n\t\t\t\t\t<div class=\"awxjs__ui-switch__control-indicator\"></div>\n\t\t\t\t</div>\n\t\t\t\t" + labels.right + "\n\t\t\t</div>\n\t\t";
  };

  return Switch;
}(_Button.default);

var _default = Switch;
exports.default = _default;
module.exports = exports.default;